import styled from '@emotion/styled';
import { rem } from '@utils';

const Main = styled.main<{ isCompact?: boolean }>(
  ({ isCompact }) => `
  background: var(--main-background-color);
  color: var(--main-color);
  container: main / inline-size;
  // content-visibility: auto;
  // contain-intrinsic-width: 100vw;
  // contain-intrinsic-height: 100vh;
  display: flex;
  align-items: center;
  flex-grow: 1;
  flex-flow: column;
  grid-area: d;
  grid-column: 2 / ${isCompact ? 3 : 4};
  overflow: hidden auto;
  padding: 0 ${rem(24)};
  z-index: 0; // fix for Safari

  @media (max-width: 768px) {
    padding: 0 ${rem(16)};
  }
`
);

const Stage = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
  flex-flow: column;
  font-size: 14px;
  line-height: 16px;
  max-width: var(--stage-width);
  width: 100%;
  height: 100%;
  position: relative;
`;

const ChatArea = styled.div`
  display: flex;
  flex-flow: column;
  flex: 1;
`;

const PromptWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: sticky;
  bottom: 0;
  padding-top: ${rem(8)};
`;

const Prompt = styled.div`
  background: var(--main-input-wrapper-background-color);

  @media (max-width: 768px) {
    bottom: ${rem(24)};
    margin: 0 ${rem(-16)};
    padding: 0 ${rem(16)};
  }
`;

const LoaderWrapper = styled.div`
  height: 100%;

  @media (max-width: 430px) {
    position: relative;
    top: calc(-1 / 2 * var(--action-panel-height));
  }
`;

const FinePrint = styled.small(
  ({ theme }) => `
  background: ${theme.palette.common.white} radial-gradient(${
    theme.palette.common.white
  } 20%, transparent);
  color: ${theme.palette.grey['600']};
  font-size: ${rem(12)};
  padding: ${rem(8)} 0;
  text-align: center;
  z-index: 1;
`
);

const Separator = styled.hr`
  background: ${({ theme }) => theme.palette.grey['200']};
  border: none;
  flex-shrink: 0;
  height: 1px;
  width: 100%;
  margin: ${rem(40)} auto;
  max-width: var(--intro-separator-max-width);

  @media (max-height: 844px) {
    margin: ${rem(24)} auto;
  }
`;

const SystemText = styled.div`
  color: ${({ theme }) => theme.palette.grey['600']};
  font-size: ${rem(14)};
  font-weight: 500;
  line-height: ${rem(16)};
  margin-top: ${rem(32)};
  text-align: center;
`;

export default {
  ChatArea,
  FinePrint,
  LoaderWrapper,
  Main,
  PromptWrapper,
  Prompt,
  Separator,
  Stage,
  SystemText
};
